import type { Meta, StoryFn } from '@storybook/react';
import type { IconProps } from './Icon';

import { Icon } from './Icon';
import { Icons } from './icons';
import styles from './story.module.css';

import { ClipboardButton } from 'storyComponents/ClipboardButton/';

const iconNames = Object.keys(Icons) as (keyof typeof Icons)[];

const codeString = '<Icon name={iconName} size={size} />';

// eslint-disable-next-line import/no-default-export
export default {
  title: 'Atoms/Icon',
  component: Icon,
  argTypes: {
    name: {
      control: { type: 'select' },
      options: iconNames,
    },
  },
  parameters: {
    inspectComponent: Icon,
    codeString: codeString,
  },
} as Meta<IconProps>;

const Template: StoryFn<IconProps> = (args) => <Icon {...args} />;

export const IconExample = Template.bind({});
IconExample.args = {
  name: 'ArrowDownOnSquare',
  size: 32,
  title: 'Optional Icon title',
};

export const IconOverview = () => {
  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(4, 1fr)',
        gridGap: '1rem',
        padding: '1rem',
        maxWidth: '1024px',
      }}
    >
      {Object.keys(Icons).map((name) => (
        <div key={name} className={styles.icon__wrapper}>
          <Icon name={name as keyof typeof Icons} size={48} />
          <div className={styles.icon__item}>
            <span>{name}</span>
            <ClipboardButton text={`<Icon icon={${name}} />`} />
          </div>
        </div>
      ))}
    </div>
  );
};
